<template>
  <DsfFormControlBox class="ds-area-select" :owner="_self" >
    <template v-slot:simple>
      <DsfTextProxy v-model="value" v-bind="_self.$props"></DsfTextProxy>
      <slot name="error">
        <div v-if="errors.length>0" class="ds-error-text">{{ errorsMsg }}</div>
      </slot>
    </template>
    <template v-slot:content>
      <!--只读状态只显示div-->
      <div v-if="readOnly" class="ds-form-readonly">
        <DsfTextProxy v-model="value" v-bind="_self.$props" :show-label="false"></DsfTextProxy>
      </div>
      <!--非只读状态：级联-->
      <dsf-area-cascader
        v-else-if="showCascader"
        class="ds-area-select-cascader"
        :class="{ 'ds-error-border': errors.length > 0 }"
        :value="value"
        :disabled="disabled"
        :readonly="readOnly"
        :code-rule="codeRule"
        :accuracy="realAccuracy"
        :placeholder="placeholder"
        :super-code="realSuperCode"
        :lazy-load-data="lazyLoadData"
        :post-has-alias="postHasAlias"
        :check-strictly="checkStrictly"
        :show-all-levels="showAllLevels"
        :options-text-field="optionsTextField"
        :selected-text-field="selectedTextField"
        @input="inputValue"
        @update:accuracy="$emit('update:accuracy', $event)"
      />
      <slot name="error">
        <div v-if="errors.length>0" class="ds-error-text">{{ errorsMsg }}</div>
      </slot>
    </template>
  </DsfFormControlBox>
</template>

<script>
export default dsf.component({
  name: "DsfAreaSelect",
  mixins: [$mixins.formControl],
  ctrlCaption: "行政区划",
  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    formatter: {
      type: String,
      default: "textValue^text"
    },
    superCode: {
      type: [String, Number],
      default: "000000000000"
    },
    // 精确度，选择到第几级: 0-省、1-市、2-区县、3-街道、4-村居
    accuracy: {
      type: Number,
      default: 4,
    },
    // 废弃
    range: {
      type: Array,
      default: null
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("items-meta-data");
      }
    },
    // 输入框中是否显示选中值的完整路径
    showAllLevels: {
      type: Boolean,
      default: true
    },
    // 是否可选择任意一级
    checkStrictly: {
      type: Boolean,
      default: false
    },
    // 提交数据是否包含别名
    postHasAlias: {
      type: Boolean,
      default: false
    },
    // 选项中显示的文本字段
    optionsTextField: {
      type: String,
      default: "name"
    },
    //选中时显示的值
    selectedTextField: {
      type: String,
      default: "name"
    },
    // 编码规则
    codeRule: {
      type: Object,
      default() {
        return {
          rootCode: '000000000000', // 根节点编码
          isFull: false, // 是否填充0
          inferCode: null // 推导编码的方法，默认为空
        };
      }
    },
    // 懒加载自定义方法, 参数（node, params, resolve）
    lazyLoadData: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      isInit: false,
      options: {},
      showCascader: true,
    };
  },
  computed: {
    // 兼容代码，兼容range参数
    realAccuracy() {
      if (this.accuracy != 4) return this.accuracy;
      let r = this.range;
      if (r) {
        return +r[1];
      }
      return this.accuracy;
    },
    realSuperCode() {
      let superCode = this.superCode;
      if (dsf.isString(superCode)) {
        superCode = this.$replace(superCode, this.$vm);
      } else {
        superCode += '';
      }
      return superCode;
    }
  },
  watch: {
    realSuperCode() {
      this.showCascader = false;
      setTimeout(() => {
        this.showCascader = true;
      }, 20);
    }
  },
  created() {
    if (this.range) {
      this.$emit('update:accuracy', +this.range[1]);
    }
  },
  methods: {
    inputValue(res) {
      this.emitValueChange(res);
      this.$nextTick(() => {
        this.emitFormValidate(res);
      });
    }
  },
  design: {
    metadata: {
      create(root) {
        let res = $mixins.formControl.design.metadata.create.call(this, root);
        let aliasIndex = _.findIndex(res.metadata.valueAttributes, (it) => it.code === "alias");
        if (this.postHasAlias && aliasIndex === -1) {
          res.metadata.valueAttributes.push({
            name: "别名",
            code: "alias",
            type: dsf.metadata.getDataType("string"),
            length: 100,
            defaultValue: null,
            encrypt: false,
            unit: null
          });
        } else if (!this.postHasAlias && aliasIndex > -1) {
          res.metadata.valueAttributes.splice(aliasIndex, 1);
        }
        return res;
      }
    }
  }
});
</script>